import React from 'react';
import { connect } from 'react-redux';
import TopHeader from '../../template/TopHeader';
import MarketingTopNav from '../MarketingTopNav';
import { PERFORMANCE_V2_VISIBLE } from '../../../config/featureFlags';
import PerformanceHub from '../../marketing-v2/features/performance/components/PerformanceHub';
import LegacyPerformance from './LegacyPerformance';

/**
 * Marketing › Performance
 * What marketing brought in, across campaigns, social, journeys, reminders,
 * loyalty, gift vouchers and the front desk. The hub and its tabs live in
 * marketing-v2/features/performance. With PERFORMANCE_V2_VISIBLE off, the
 * page as it was (LegacyPerformance).
 */

function MarketingPerformance(props) {
  return (
    <div className="h_n catalogue-no-header">
      <div className="body_container cm_bg_white">
        <TopHeader title="" {...props} />
        <div className="catalogue-page-wrapper">
          <MarketingTopNav activeTab="performance" />
          <div className="catalogue-content-container">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {PERFORMANCE_V2_VISIBLE
                    ? <PerformanceHub dispatch={props.dispatch} history={props.history} location={props.location} currency={props.user?.userInfo?.hairdresser?.currencySymbol || '£'} />
                    : <LegacyPerformance dispatch={props.dispatch} history={props.history} />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return { ...state };
}

export default connect(mapStateToProps)(MarketingPerformance);
